import * as React from 'react'

function IconLeaf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={218}
      height={203}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M174.105 42.245l34.607-17.859-33.855 26.465s40.489 5.434 42.96-32.484c-.009-.01-40.695-9.786-43.712 23.878zM45.302 97.04L35.33 61.531l19.21 37.005S70.595 63.613 31.31 51.86c0-.008-20.684 34.01 13.99 45.178zM44.875 170.822l29.684 24.428-38.256-20.99s7.748 37.119 47.416 26.988c0 0-3.353-38.707-38.844-30.426zM120.594 68.33l-.048-36.586 8.589 40.12s24.968-30.123-9.851-50.379c0 0-29.2 28.204 1.31 46.845z"
        fill="#F4BA27"
      />
      <path
        d="M175.588 0c-5.379 45.475-27.318 89.473-61.923 122.278-23.867 22.629-53.709 39.871-86.092 50.473A245.328 245.328 0 010 180.033v-13.357a229.744 229.744 0 0019.311-5.066 229.63 229.63 0 0024.312-9.073c22.28-9.793 42.715-23.081 59.862-39.34C135.566 82.791 156.021 42.121 161.324 0h14.264z"
        fill="#1978B2"
      />
      <path
        d="M108.168 0c-10.19 54.05-32.241 106.122-64.623 152.236-.199.278-.387.556-.585.833-5.426 7.684-10.568 14.042-15.437 19.341C17.097 183.719 7.926 190.155 0 194.109v-15.403c7.256-4.778 13.606-10.876 19.277-17.415 4.293-4.97 8.199-10.199 11.813-15.308C62.312 101.76 83.683 51.847 93.788 0h14.38z"
        fill="#219321"
      />
    </svg>
  )
}

export default IconLeaf
